module.exports = __webpack_public_path__ + "static/media/icon-prize-3d.64e31423.png";